import { Attributes } from '~shared/models';

export function mapOfferItemAttributes(offer: any) {
  if (offer.item.attributes && !(offer.item.attributes instanceof Attributes)) {
    return {
      ...offer,
      item: {
        ...offer.item,
        attributes: Attributes.map(offer.item.attributes),
      },
    };
  } else {
    return offer;
  }
}
